import { render, staticRenderFns } from "./Journals.vue?vue&type=template&id=05ddd44a&scoped=true&"
import script from "./Journals.vue?vue&type=script&lang=js&"
export * from "./Journals.vue?vue&type=script&lang=js&"
import style0 from "./Journals.vue?vue&type=style&index=0&id=05ddd44a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ddd44a",
  null
  
)

export default component.exports